import { render } from "./Meigaranews.vue?vue&type=template&id=dc88ccdc&scoped=true"
import script from "./Meigaranews.vue?vue&type=script&lang=js"
export * from "./Meigaranews.vue?vue&type=script&lang=js"

import "./Meigaranews.vue?vue&type=style&index=0&id=dc88ccdc&scoped=true&lang=scss"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc88ccdc"]])

export default __exports__